import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { CryptoPaymentMethodType } from "../components/common/CryptoPaymentMethod.js";
import { useConnectedWalletDisplay } from "./useConnectedWalletDisplay.js";
/**
 * Custom hook to automatically select appropriate crypto payment method
 * based on available wallets and balance.
 *
 * Auto-selection logic:
 * - Only auto-selects when selectedCryptoPaymentMethod is NONE (user hasn't explicitly chosen)
 * - If EOA/Wagmi wallet connected + has balance → CONNECT_WALLET
 * - If EOA/Wagmi wallet connected + insufficient balance → TRANSFER_CRYPTO
 * - If only Global wallet available → GLOBAL_WALLET
 * - If no wallets → remains NONE
 */
export function useAutoSelectCryptoPaymentMethod(t0) {
  const $ = _c(8);
  const {
    paymentType: t1,
    setCryptoPaymentMethod,
    selectedCryptoPaymentMethod,
    hasEnoughBalance,
    isBalanceLoading
  } = t0;
  const paymentType = t1 === undefined ? "crypto" : t1;
  const {
    suggestedPaymentMethod
  } = useConnectedWalletDisplay(selectedCryptoPaymentMethod);
  let t2;
  let t3;
  if ($[0] !== hasEnoughBalance || $[1] !== isBalanceLoading || $[2] !== paymentType || $[3] !== selectedCryptoPaymentMethod || $[4] !== setCryptoPaymentMethod || $[5] !== suggestedPaymentMethod) {
    t2 = () => {
      if (paymentType !== "crypto") {
        return;
      }
      if (selectedCryptoPaymentMethod !== CryptoPaymentMethodType.NONE) {
        return;
      }
      if (suggestedPaymentMethod !== CryptoPaymentMethodType.NONE) {
        if (!isBalanceLoading) {
          if (hasEnoughBalance && suggestedPaymentMethod === CryptoPaymentMethodType.CONNECT_WALLET) {
            setCryptoPaymentMethod(CryptoPaymentMethodType.CONNECT_WALLET);
          } else {
            if (!hasEnoughBalance && suggestedPaymentMethod === CryptoPaymentMethodType.CONNECT_WALLET) {
              setCryptoPaymentMethod(CryptoPaymentMethodType.TRANSFER_CRYPTO);
            } else {
              setCryptoPaymentMethod(suggestedPaymentMethod);
            }
          }
        } else {
          setCryptoPaymentMethod(suggestedPaymentMethod);
        }
      }
    };
    t3 = [paymentType, setCryptoPaymentMethod, selectedCryptoPaymentMethod, suggestedPaymentMethod, hasEnoughBalance, isBalanceLoading];
    $[0] = hasEnoughBalance;
    $[1] = isBalanceLoading;
    $[2] = paymentType;
    $[3] = selectedCryptoPaymentMethod;
    $[4] = setCryptoPaymentMethod;
    $[5] = suggestedPaymentMethod;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
}